export default {
  title: 'Szczegóły zamówienia',
};
